import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import authReducer from './slices/authSlice';
import jobsReducer from './slices/jobsSlice';
import settingsReducer from './slices/settingsSlice';
import appReducer from './slices/appSlice';
import adminContextReducer from './slices/adminContextSlice';

const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    jobs: jobsReducer,
    settings: settingsReducer,
    adminContext: adminContextReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/login/fulfilled', 'auth/register/fulfilled'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
